import React from "react"

export const AngleLeft = () => {
  return (
    <svg width="1601" height="901" viewBox="0 0 1601 901" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.5" d="M0.258789 610.319L448.259 461.91L448.259 900.701H0.258789L0.258789 610.319Z" fill="currentcolor"/>
    </svg>
  )
}